import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface CommissionApprovalItem {
  sourceType: 'BOOKING' | 'TOUR';
  id: string;
  code: string;
  bookingCode: string;
  customerName: string;
  tripName: string;
  travelDate: string;
  travelerCount: number;
  saleName: string;
  bookingAmount: number | string;
  saleCommission: number | string;
  specialCommission: number | string;
  commissionRate: number | string | null;
  commissionAmount: number | string;
  recoveryDeduction: number | string;
  netPaymentAmount: number | string;
  attachmentFileName: string;
  attachmentUrl: string | null;
  purchaseOrderUrl: string | null;
  tour: {
    id: string;
    tourNo: string;
    tourCode: string;
    tourName: string;
    country: string;
    tourType: 'JOIN_TOUR' | 'GROUP_TOUR';
    travelDate: string;
    returnDate: string | null;
    tourPrice: number | string;
  } | null;
  status: 'SUPERVISOR_REVIEW';
  submittedAt: string;
}

@Injectable({ providedIn: 'root' })
export class CommissionApprovalService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/commissions/supervisor-review`;
  async getPending(): Promise<CommissionApprovalItem[]> {
    const response = await firstValueFrom(
      this.http.get<{ commissions: CommissionApprovalItem[] }>(this.apiUrl, {
        withCredentials: true,
      }),
    );
    return response.commissions;
  }
  async approve(id: string, sourceType: CommissionApprovalItem['sourceType']): Promise<void> {
    await firstValueFrom(
      this.http.patch(`${this.apiUrl}/${id}/approve`, { sourceType }, { withCredentials: true }),
    );
  }
  async reject(id: string, sourceType: CommissionApprovalItem['sourceType']): Promise<void> {
    await firstValueFrom(
      this.http.patch(`${this.apiUrl}/${id}/reject`, { sourceType }, { withCredentials: true }),
    );
  }
  resolveFileUrl(fileUrl: string): string {
    if (/^https?:\/\//i.test(fileUrl)) return fileUrl;
    if (/^https?:\/\//i.test(environment.apiUrl))
      return `${new URL(environment.apiUrl).origin}${fileUrl}`;
    return fileUrl;
  }
}
